/**
 * orga-app-api - einlasskontrolle-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CoronaCertValidationRequest { 
    qr_code: string;
    demo_modus?: boolean;
    demo_index?: number;
    uve_dev?: boolean;
    test_erlaubt?: boolean;
    protokoll_aktiv?: boolean;
    immer_stichprobe?: boolean;
}

